
export function useClickOut(vm, handler) {
    const handleDocumentClicked = (e) => {
        if(e.target && !vm.$el?.contains(e.target)) {
            handler();
        }
    }

    document.addEventListener('click', handleDocumentClicked);

    vm.$on('hook:beforeDestroy', () => {
        document.removeEventListener('click', handleDocumentClicked);
    });
}
